import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=25c031bc&"
import script from "./Actions.vue?vue&type=script&lang=js&"
export * from "./Actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports